import type { CoursePlanItem } from "../auth/api-client";

function findAnchorIndex(
  planItems: readonly CoursePlanItem[],
  insertAfterPlanItemId: string | null | undefined
): number | null {
  if (insertAfterPlanItemId === null) return null;
  if (insertAfterPlanItemId === undefined) {
    return planItems.length > 0 ? planItems.length - 1 : null;
  }
  let idx = planItems.findIndex((p) => p.planItemId === insertAfterPlanItemId);
  if (idx < 0) {
    idx = planItems.findIndex(
      (p) => p.itemKind === "lesson" && p.lesson.id === insertAfterPlanItemId
    );
  }
  return idx >= 0 ? idx : null;
}

/** Lesson the quiz should draw from at the insert slot (anchor item or nearest prior lesson). */
export function precedingLessonTitle(
  planItems: readonly CoursePlanItem[],
  insertAfterPlanItemId: string | null | undefined
): string | null {
  const anchorIndex = findAnchorIndex(planItems, insertAfterPlanItemId);
  if (anchorIndex === null) return null;
  for (let i = anchorIndex; i >= 0; i--) {
    const item = planItems[i];
    if (item?.itemKind === "lesson") return item.lesson.title;
  }
  return null;
}

export function defaultQuizTitle(
  planItems: readonly CoursePlanItem[],
  insertAfterPlanItemId: string | null | undefined
): string {
  const lesson = precedingLessonTitle(planItems, insertAfterPlanItemId);
  if (lesson) return `Quiz: ${lesson}`;
  return "New quiz";
}

export function resolveQuizTitle(
  customTitle: string,
  planItems: readonly CoursePlanItem[],
  insertAfterPlanItemId: string | null | undefined
): string {
  const trimmed = customTitle.trim();
  if (trimmed) return trimmed;
  return defaultQuizTitle(planItems, insertAfterPlanItemId);
}
